<template>
    <div class="calendar-outer-wrapper" id="calendar-outer-wrapper">
        <div class="calendar-wrapper"><div class="grid-item calendar-header bar header">
            <button type="button" class="option-toggle collapsed">
                <span class="icon-bar top"></span>
                <span class="icon-bar middle"></span>
                <span class="icon-bar bottom"></span>
            </button>
            <button class="btn header quick collapsed">Quick Select</button>
            <button @click="switchCalendar('month')" class="btn header switch-calendar month" :class="{selected:range=='month'}" range="month">Month</button>
            <button @click="switchCalendar('day')" class="btn header switch-calendar day" :class="{selected:range=='day'}" range="day">Day</button>
            <button @click="switchCalendar('quarter')" class="btn header switch-calendar quarter" :class="{selected:range=='quarter'}" range="quarter">Quarter</button>
            <button @click="switchCalendar('week')" class="btn header switch-calendar week" :class="{selected:range=='week'}" range="week">Week</button>
            <button class="btn header compare collapsed">Compare With</button>
            <i id="close-calendar" @click="closeCalendar()" class="fa fa-close"></i>
        </div>
            <div class="grid-item calendar-options">
                <ul v-if="range=='month'" class="nav navbar calendar quick month">
                    <li class="title">Quick Select:</li>
                    <li v-for="(item, index) in calendarInfos.calendar_ranges.month" @click="mainSelection($event, item)" :class="[item.main_method, {selected:item.main_method==currentMainMethod}, {first:!index}, {'hidden':!item.date_from}]"
                        :main_method = "item.main_method"
                        :name        = "item.name"
                        :range       = "item.range"
                        :date_from   = "item.date_from"
                        :date_to     = "item.date_to">
                        <a>{{item.name}}</a>
                    </li>
                </ul>
                <ul v-if="range=='day'" class="nav navbar calendar quick day">
                    <li class="title">Quick Select:</li>
                    <li v-for="(item, index) in calendarInfos.calendar_ranges.day" @click="mainSelection($event, item)" :class="[item.main_method, {selected:item.main_method==currentMainMethod}, {first:!index}, {'hidden':!item.date_from}]"
                        :main_method = "item.main_method"
                        :name        = "item.name"
                        :range       = "item.range"
                        :date_from   = "item.date_from"
                        :date_to     = "item.date_to">
                        <a>{{item.name}}</a>
                    </li>
                </ul>
                <ul v-if="range=='quarter'" class="nav navbar calendar quick quarter">
                    <li class="title">Quick Select:</li>
                    <li v-for="(item, index) in calendarInfos.calendar_ranges.quarter" @click="mainSelection($event, item)" :class="[item.main_method, {selected:item.main_method==currentMainMethod}, {first:!index}, {'hidden':!item.date_from}]"
                        :main_method = "item.main_method"
                        :name        = "item.name"
                        :range       = "item.range"
                        :date_from   = "item.date_from"
                        :date_to     = "item.date_to">
                        <a>{{item.name}}</a>
                    </li>
                </ul>
                <ul v-if="range=='week'" class="nav navbar calendar quick week">
                    <li class="title">Quick Select:</li>
                    <li v-for="(item, index) in calendarInfos.calendar_ranges.week" @click="mainSelection($event, item)" :class="[item.main_method, {selected:item.main_method==currentMainMethod}, {first:!index}, {'hidden':!item.date_from}]"
                        :main_method = "item.main_method"
                        :name        = "item.name"
                        :range       = "item.range"
                        :date_from   = "item.date_from"
                        :date_to     = "item.date_to">
                        <a>{{item.name}}</a>
                    </li>
                </ul>
            </div>
            <div class="grid-item calendar-comparison">
                <ul class="nav navbar calendar compare">
                    <li class="title">Compare With:</li>
                    <li v-for="(item, key, index) in calendarInfos.calendar_compares" @click="compareSelection($event, item)" :class="[item.main_method, item.comp_method, {selected:item.comp_method==currentCompMethod}, {first:item.isFirst}, {'hidden':item.main_method!=currentMainMethod || !item.date_from || ((item.name=='Custom') && (range!=item.range))}]"
                        :main_method = "item.main_method"
                        :comp_method = "item.comp_method"
                        :name        = "item.name"
                        :range        = "item.range"
                        :date_from   = "item.date_from"
                        :date_to     = "item.date_to"
                        :full_to     = "item.full_to">
                        <a>{{item.name}}</a>
                    </li>
                </ul>
            </div>
            <div class="grid-item calendar-body">
                <i v-if="range=='month'" class="fa fa-chevron-left calendar-scroll left month" range="month"></i>
                <i v-if="range=='month'" class="fa fa-chevron-right calendar-scroll right month disabled" range="month"></i>
                <i v-if="range=='day'" class="fa fa-chevron-left calendar-scroll left day" range="day"></i>
                <i v-if="range=='day'" class="fa fa-chevron-right calendar-scroll right day disabled" range="day"></i>
                <i v-if="range=='quarter'" class="fa fa-chevron-left calendar-scroll left quarter" range="quarter"></i>
                <i v-if="range=='quarter'" class="fa fa-chevron-right calendar-scroll right quarter disabled" range="quarter"></i>
                <i v-if="range=='week'" class="fa fa-chevron-left calendar-scroll left week" range="week"></i>
                <i v-if="range=='week'" class="fa fa-chevron-right calendar-scroll right week disabled" range="week"></i>
                <div v-show="range=='month'" class="month-box-wrapper calendar month">
                    <div v-for="(year, key, year_index) in calendarInfos.years" class="month-box-outer box-outer">
                        <span class="year-title">{{year}}</span>
                        <div class="month-box-inner box-inner">
                            <div v-for="(month, month_index) in calendarInfos.month_arr" range="month" class="box month-box month" :class="['month_box_'+((month_index+1)+(year_index*12)), calendarInfos[year][month]['disabled'], calendarInfos[year][month]['selected']]"
                                 @click="selectBox((month_index+1)+(year_index*12), calendarInfos[year][month]['date_from'], calendarInfos[year][month]['date_to'])"
                                 :box_num = "(month_index+1)+(year_index*12)"
                                 :date_from ="calendarInfos[year][month]['date_from']"
                                 :date_to = "calendarInfos[year][month]['date_to']">
                                {{month}}
                            </div>
                        </div>
                    </div>
                </div>
                <div v-show="range=='day'" class="day-box-wrapper calendar day">
                    <div v-for="(item, key, month_count) in calendarInfos.months" class="day-box-outer box-outer">
                        <span :date_from="item.date_from" :date_to="item.date_to" class="month-title">{{key}}</span>
                        <div class="week-head-wrap"><div class="week-head">{{calendarInfos.week_arr[0]}}</div><div class="week-head">{{calendarInfos.week_arr[1]}}</div><div class="week-head">{{calendarInfos.week_arr[2]}}</div><div class="week-head">{{calendarInfos.week_arr[3]}}</div><div class="week-head">{{calendarInfos.week_arr[4]}}</div><div class="week-head">{{calendarInfos.week_arr[5]}}</div><div class="week-head">{{calendarInfos.week_arr[6]}}</div></div>
                        <div class="day-box-inner box-inner">
                            <div v-for="(day, index) in item.dummies" class="box day-box day disabled">{{day}}</div>
                            <div v-for="(day, index) in calendarInfos.day_arr" v-if="calendarInfos[key][day]['visible']" range="day" class="box day-box day" :class="['day_box_'+((index+1)+(calendarInfos[key][day]['days_offset'])), ''+(index+1), calendarInfos[key][day]['disabled'], calendarInfos[key][day]['selected']]"
                                 @click="selectBox((index+1)+(calendarInfos[key][day]['days_offset']), calendarInfos[key][day]['date_from'], calendarInfos[key][day]['date_to'])"
                                 :box_num = "(index+1)+(calendarInfos[key][day]['days_offset'])"
                                 :date_from ="calendarInfos[key][day]['date_from']"
                                 :date_to = "calendarInfos[key][day]['date_to']">
                                {{day}}
                            </div>
                        </div>
                    </div>
                </div>
                <div v-show="range=='quarter'" class="quarter-box-wrapper calendar quarter">
                    <div v-for="(year, key, year_index) in calendarInfos.years" class="quarter-box-outer box-outer">
                        <span class="year-title">{{year}}</span>
                        <div class="quarter-box-inner box-inner">
                            <div v-for="(quarter, quarter_index) in calendarInfos.quarter_arr" range="quarter" class="box quarter-box quarter" :class="['quarter_box_'+((quarter_index+1)+(year_index*4)), calendarInfos[year][quarter]['disabled'], calendarInfos[year][quarter]['selected']]"
                                 @click="selectBox((quarter_index+1)+(year_index*4), calendarInfos[year][quarter]['date_from'], calendarInfos[year][quarter]['date_to'])"
                                 :box_num = "(quarter_index+1)+(year_index*4)"
                                 :date_from ="calendarInfos[year][quarter]['date_from']"
                                 :date_to = "calendarInfos[year][quarter]['date_to']">
                                {{quarter}}
                            </div>
                        </div>
                    </div>
                </div>
                <div v-show="range=='week'" class="week-box-wrapper calendar week">
                    <div v-for="(year, key, year_index) in calendarInfos.years" class="week-box-outer box-outer">
                        <span class="year-title">{{year}}</span>
                        <div class="week-box-inner box-inner">
                            <div v-for="(week, week_key, week_index) in calendarInfos[year]['weeks']" range="week" class="box week-box week" :class="['week_box_'+((week_index+1)+(calendarInfos[year][week_key]['weeks_offset'])), calendarInfos[year][week_key]['disabled'], calendarInfos[year][week_key]['selected']]"
                                 @click="selectBox((week_index+1)+(calendarInfos[year][week_key]['weeks_offset']), calendarInfos[year][week_key]['date_from'], calendarInfos[year][week_key]['date_to'])"
                                 :box_num = "(week_index+1)+(calendarInfos[year][week_key]['weeks_offset'])"
                                 :date_from ="calendarInfos[year][week_key]['date_from']"
                                 :date_to = "calendarInfos[year][week_key]['date_to']"
                                 :title = "calendarInfos[year][week_key]['date_from'] + ' to ' + calendarInfos[year][week_key]['date_to']">
                                {{week_key}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="grid-item calendar-footer bar footer">
                <div class="period-button-wrap">
                    <span :class="{ 'switch-selected' : period=='main' }" class="switch-text">Main Period</span>
                    <p-input type="checkbox" class="p-switch p-slim p-large" @change="switchPeriod" :checked="period=='compare'"></p-input>
                    <span :class="{ 'switch-selected' : period=='compare' }" class="switch-text">Compare Period</span>
                </div>
                <button id="calendar-save-selection" class="btn footer active main-button-large" :class="{disabled:save_disabled}" :disabled="save_disabled" :title="save_disabled ? 'Nothing to save' : ''">Save Selection</button>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        created(){
            event_bus.$on('date_infos', (param) => {
                this.fetchServerData(param);
            });
        },
        mounted(){
            const vueInstance = this;
            setTimeout(function(){
                vueInstance.calendar();
            }, 2000);
        },
        data() {
            return {
                calendarInfos:{
                    calendar_ranges:{
                        day:[],
                        month:[],
                        quarter:[],
                        week:[]
                    }
                },
                state:'closed',//main state
                range:'day',//sub-state values:day, month, week, quarter
                period:'main',//sub-state values: main, compare
                savedRange:null,
                currentMainMethod:null,
                currentCompMethod:null,
                currentCompSel:null,
                savedMainMethod:null,
                savedCompMethod:null,
                mainMethodsByRange:null,
                date_from:null,
                date_to:null,
                date_compare_from:null,
                date_compare_to:null,
                date_full_to:null,
                save_disabled:true,
                section:'quick'
            }
        },
        methods: {
            fetchServerData(param) {
                const has_signature = _.isObject(param) && _.has(param, 'signature');
                let report_id = this.$route.params.report_id;

                if(has_signature) return;

                axios.get(`/api/reporting/calendar/get/${report_id}`).then((result) => {
                    if(!result.data.error){
                        this.calendarInfos = result.data;
                        this.currentMainMethod = result.data['currentMainMethod'];
                        this.currentCompSel = result.data['currentCompSel'];
                        this.currentCompMethod = this.currentCompSel[this.currentMainMethod];
                        this.mainMethodsByRange = result.data['mainMethodsByRange'];
                        this.date_from = this.calendarInfos.calendar_mains[this.currentMainMethod]['date_from'];
                        this.date_to = this.calendarInfos.calendar_mains[this.currentMainMethod]['date_to'];
                        this.date_compare_from = this.calendarInfos.calendar_compares[this.currentCompMethod]['date_from'];
                        this.date_compare_to = this.calendarInfos.calendar_compares[this.currentCompMethod]['date_to'];
                        this.date_full_to = this.calendarInfos.calendar_compares[this.currentCompMethod]['full_to'];
                        this.savedRange = this.$store.state.current_dates.range;
                        this.savedMainMethod = this.$store.state.current_dates.main_method;
                        this.savedCompMethod = this.$store.state.current_dates.comp_method;
                    }
                });
            },
            updateDates(){
                const vueInstance = this;

                this.date_from = this.calendarInfos.calendar_mains[this.currentMainMethod]['date_from'];
                this.date_to = this.calendarInfos.calendar_mains[this.currentMainMethod]['date_to'];
                this.date_compare_from = this.calendarInfos.calendar_compares[this.currentCompMethod]['date_from'];
                this.date_compare_to = this.calendarInfos.calendar_compares[this.currentCompMethod]['date_to'];
                this.date_full_to = this.calendarInfos.calendar_compares[this.currentCompMethod]['full_to'];
                setTimeout(function(){
                    vueInstance.setCalendar();
                }, 50);
            },
            switchCalendar(range){
                this.range = range;
                this.period = 'main';
                if((range == this.savedRange) && (this.currentMainMethod != 'custom')){
                    this.currentMainMethod = this.savedMainMethod;
                }
                else if(!this.mainMethodsByRange[range][this.currentMainMethod] || (this.currentMainMethod == 'custom')){
                    this.currentMainMethod = _.values(this.mainMethodsByRange[range])[0];
                }
                this.currentCompMethod = this.currentCompSel[this.currentMainMethod];

                this.updateDates();
                this.setSubmitButton();
            },
            closeCalendar(){
                if(this.state=='closed') return;

                $('.calendar-outer-wrapper').addClass('closing').animate({top:'-60rem'}, function(){
                    $(this).removeClass('visible').css('top','-999rem').removeClass('closing');
                });

                this.save_disabled = true;

                $.event.trigger({
                    type: "calendar-close"
                });
            },
            switchPeriod(period){
                const vueInstance = this;
                if (this.period == 'main') {
                    this.period = 'compare';
                    this.section = 'compare';
                } else {
                    this.period = 'main';
                    this.section = 'quick';
                }

                setTimeout(function(){
                    vueInstance.setCalendar();
                }, 50);
            },
            mainSelection(event, item){
                this.period = 'main';
                this.currentMainMethod = item.main_method;
                this.currentCompMethod = this.currentCompSel[this.currentMainMethod];

                this.updateDates();
                this.setSubmitButton();
            },
            compareSelection(event, item){
                this.period = 'compare';
                this.section = 'compare';
                this.currentCompSel[this.currentMainMethod] = item.comp_method;
                this.currentCompMethod = item.comp_method;

                this.updateDates();
                this.setSubmitButton();
            },
            selectBox(boxNum, date_from, date_to){

            },
            calendar(){
                const vueInstance = this;
                var select_status = 0;
                var first = null;
                var last = null;
                var box = null;
                var period = null;
                vueInstance.init(select_status, first, last, box, period);
                $('button.quick, button.compare').click(function(){
                    var $this = $(this);
                    var cls = $this.hasClass('quick') ? 'quick' : 'compare';
                    if($this.hasClass('collapsed')){
                        $this.removeClass('collapsed');
                        $('ul.'+cls).slideDown();
                    }
                    else{
                        $this.addClass('collapsed');
                        $('ul.'+cls).slideUp();
                    }
                });
                $('button.option-toggle').click(function(){
                    var $this = $(this);
                    if($this.hasClass('collapsed')){
                        $this.removeClass('collapsed');
                        $('ul.quick, ul.compare').slideDown();
                    }
                    else{
                        $this.addClass('collapsed');
                        $('ul.quick, ul.compare').slideUp();
                    }
                });
                $(window).resize(function() {
                    $('ul.quick, ul.compare').attr('style', 'none');
                    var cal = $('.calendar-outer-wrapper');
                    cal.removeClass('more');
                    if($('#navbar').height() > 60){
                        cal.addClass('more');
                    }
                    vueInstance.calendarResize();
                });
                $('#date-selected').off('click').click(function(){
                    vueInstance.period = 'main';
                    var $this = $(this);
                    var nav2 = $('.navbar-custom.second');
                    if(vueInstance.state == 'closed'){
                        vueInstance.state = 'visible';
                        vueInstance.updateDates();
                        var f = $('nav.sidebar').find('ul.title');
                        if(f.hasClass('expanded')){
                            f.find('a.nav-link').click();
                        }
                        $this.addClass('visible');
                        var navHeight = $('#navbar').height();

                        var Top = '5.8rem';//'8.2rem';
                        var additionalClass= 0;
                        nav2.addClass('calendarAnimating');
                        $('.calendar-outer-wrapper').css('top','-90rem').removeClass('hidden').animate({top:Top}, function(){
                            if(!!additionalClass)
                                $(this).addClass('more');

                            $(this).addClass('visible').attr('style', 'none');
                            nav2.removeClass('calendarAnimating');
                        });
                    }
                    else{
                        $this.removeClass('visible');
                        nav2.addClass('calendarAnimating');
                        $('.calendar-outer-wrapper').addClass('closing').animate({top:'-60rem'}, function(){
                            $(this).removeClass('visible').css('top','-999rem').removeClass('closing');
                            nav2.removeClass('calendarAnimating').addClass('hidden');
                        });
                        $.event.trigger({
                            type: "calendar-close"
                        });
                    }
                });

                $('.calendar-scroll').click(function(){
                    var $this = $(this);

                    if($this.hasClass('disabled')) return;

                    var direction = ($this.hasClass('left')) ? 'left' : 'right';
                    var box = $this.attr('range');
                    var scroll = box;
                    var wrapper = $('.'+box+'-box-wrapper');

                    var w = $('.'+box+'-box-outer:visible:last').width();
                    var m = wrapper.css('margin-right').split('px')[0];

                    $this.addClass('disabled');
                    if(direction == 'left'){
                        wrapper.animate({'marginRight':m-w}, function(){
                            $('.'+box+'-box-outer:visible:last').addClass('hidden');
                            $(this).css('marginRight', m);
                            var position = $('.'+box+'-box-outer').position();
                            $('.calendar-scroll.'+scroll).removeClass('disabled');
                            if(Math.abs(position.left) < 100) $('.calendar-scroll.left.'+scroll).addClass('disabled');
                        });
                    }
                    else{
                        $('.'+box+'-box-outer:hidden:first').removeClass('hidden');
                        wrapper.css('marginRight', m-w).animate({'marginRight':m}, function(){
                            var last = $('.'+box+'-box-outer:last');
                            $('.calendar-scroll.'+scroll).removeClass('disabled');
                            if(!last.hasClass('hidden')) $('.calendar-scroll.right.'+scroll).addClass('disabled');
                        });
                    }
                });
                $('#calendar-save-selection').click(function(){
                    var calendar = $('.switch-calendar.selected').attr('range');
                    var main_box = $('ul.quick').not('.hidden').find('li.selected');
                    var comp_box = $('ul.compare').find('li.selected').not('.hidden');

                    var date_from = main_box.attr('date_from');
                    var date_to = main_box.attr('date_to');
                    var main_method = main_box.attr('main_method');
                    var comp_method = comp_box.attr('comp_method');

                    var date_compare_from = comp_box.attr('date_from');
                    var date_compare_to = comp_box.attr('date_to');

                    if(!date_from || !date_to || !date_compare_from || !date_compare_to || !main_method || !comp_method){
                        alert("The selection cannot be saved, because some data is not yet available: wait and try again");
                        return;
                    }

                    var dateSelected = $('#date-selected');
                    dateSelected.attr('date_from', date_from);
                    dateSelected.attr('date_to', date_to);
                    dateSelected.attr('date_compare_from', date_compare_from);
                    dateSelected.attr('date_compare_to', date_compare_to);

                    dateSelected.attr('main_method', main_method);
                    dateSelected.attr('comp_method', comp_method);

                    dateSelected.attr('calendar', calendar);

                    var main_period = $('ul.quick').not('.hidden').find('li.selected').not('.hidden').find('a').text();
                    var compare_period = $('ul.compare').find('li.selected').not('.hidden').find('a').text();
                    $('#date-selected').find('span.date-text').html(main_period + ' vs ' + compare_period);
                    $('#close-calendar').click();

                    var currentDates = {
                        'main_period'           : main_period,
                        'compare_period'        : compare_period,
                        'main_method'           : main_method,
                        'comp_method'           : comp_method,
                        'date_from'             : date_from,
                        'date_to'               : date_to,
                        'date_compare_from'     : date_compare_from,
                        'date_compare_to'       : date_compare_to,
                        'start_date'            : vueInstance.$store.state.current_dates.start_date,
                        'first_day_of_week'     : vueInstance.$store.state.current_dates.first_day_of_week,
                        'calendar'              : calendar
                    };

                    vueInstance.$store.commit('setCurrentDates',currentDates);
                    //vueInstance.showLoader();
                    vueInstance.savedMainMethod = vueInstance.currentMainMethod;
                    vueInstance.savedCompMethod = vueInstance.currentCompMethod;
                    vueInstance.savedRange = vueInstance.range;

                    event_bus.$emit('calendar_saved', true);
                });
            },
            calendarResize(){
                const vueInstance = this;
                $('#close-calendar').click();
                clearTimeout(window.resizedFinished);
                window.resizedFinished = setTimeout(function(){
                    $('.calendar-scroll').each(function(i, el){
                        var $el = $(el);

                        var direction = ($el.hasClass('left')) ? 'left' : 'right';

                        if(direction=='left'){
                            $el.removeClass('disabled');
                            var box = $el.attr('range');
                            var hide = ($('.'+box+'-box-wrapper').hasClass('hidden')) ? true : false;
                            $('.'+box+'-box-wrapper').removeClass('hidden');//we remove the hidden class to calculate the width
                            var el1 = $('.calendar-body');
                            var el2 = $('.'+box+'-box-wrapper');

                            var p1 = el1.position();
                            var p2 = el2.first().position();

                            var l1 = p1.left;
                            var l2 = p2.left;

                            if(l1<(l2/2)){
                                $('.calendar-scroll.right.'+box).click();
                                setTimeout(function(){
                                    var w1 = el1.width();
                                    var w2 = el2.width();
                                    if(w2 < (w1+w2/4)){
                                        $('.calendar-scroll.left.'+box).addClass('disabled');
                                    }
                                    if(hide) $('.'+box+'-box-wrapper').addClass('hidden');
                                }, 500);
                            }
                            else{
                                var w1 = el1.width();
                                var w2 = el2.width();
                                if(w2 < (w1+w2/4)){
                                    $('.calendar-scroll.left.'+box).addClass('disabled');
                                }
                                if(hide) $('.'+box+'-box-wrapper').addClass('hidden');
                            }
                        }
                    });
                }, 500);
            },
            resetCalendarBoxes(){
                if(this.state != 'visible') return;
                var outer = $('.calendar-outer-wrapper');
                outer.find('.box').removeClass('selected');
                outer.find('ul.calendar').find('li.selected').not('.custom').removeClass('selected');
                outer.find('ul.calendar.compare').find('li').not('.custom').not('.title').addClass('hidden');
                outer.find('ul.calendar.compare').find('li.first').addClass('selected');

                this.setSubmitButton();
            },
            resetCustom(){
                const vueInstance = this;
                var outer = $('.calendar-outer-wrapper');
                outer.find('li.custom').each(function(i, el){
                    var $el = $(el);
                    $el.attr('date_from', '');
                    $el.attr('date_to', '');
                });
                vueInstance.setSubmitButton();
            },
            getActivePeriod(){
                return this.section;
            },
            getCurrentSelection(){
                const vueInstance = this;
                var calendar = $('.switch-calendar.selected').attr('range');
                var main_box = $('ul.quick').not('.hidden').find('li.selected');
                var comp_box = $('ul.compare').find('li.selected').not('.hidden');

                var date_from = main_box.attr('date_from');
                var date_to = main_box.attr('date_to');

                var date_compare_from = comp_box.attr('date_from');
                var date_compare_to = comp_box.attr('date_to');

                if((Date.parse(date_from)) && (Date.parse(date_to)) && (Date.parse(date_compare_from)) && (Date.parse(date_compare_to))){
                    var range = {'date_from':date_from, 'date_to':date_to, 'date_compare_from':date_compare_from, 'date_compare_to':date_compare_to};
                    return JSON.stringify(range);
                }

                return false;
            },
            getActiveSelection(){
                const vueInstance = this;
                var dates = $('#date-selected');

                var date_from = dates.attr('date_from');
                var date_to = dates.attr('date_to');

                var date_compare_from = dates.attr('date_compare_from');
                var date_compare_to = dates.attr('date_compare_to');

                var range = {'date_from':date_from, 'date_to':date_to, 'date_compare_from':date_compare_from, 'date_compare_to':date_compare_to};

                return JSON.stringify(range);
            },
            compareDates(){
                const vueInstance = this;
                var current = vueInstance.getCurrentSelection();

                if(current === false) {
                    return true;//we use it to disable the submit button, when some range is not yet selected
                }

                var active = vueInstance.getActiveSelection();
                return current == active;
            },
            setSubmitButton(){
                let check1 = this.savedMainMethod == this.currentMainMethod;
                let check2 = this.savedCompMethod == this.currentCompMethod;
                let check3 = this.savedRange == this.range;
                let check4 = this.$store.state.current_dates.date_from == this.date_from;
                let check5 = this.$store.state.current_dates.date_to == this.date_to;
                let check6 = this.$store.state.current_dates.date_compare_from == this.date_compare_from;
                let check7 = this.$store.state.current_dates.date_compare_to == this.date_compare_to;

                this.save_disabled = check1 && check2 && check3 && check4 && check5 && check6;
            },
            setCalendar(){
                const vueInstance = this;
                var date_from = (this.period == 'main') ? this.date_from : this.date_compare_from;
                var date_to = (this.period == 'main') ? this.date_to : this.date_compare_to;
                var full_to = (this.period == 'main') ? this.date_to : this.date_full_to;

                $('.box-inner .box').removeClass('selected').closest('.box-outer').removeClass('selected');

                var c = this.range;
                var check = 0;
                var date_to_use = (c == 'day') ? date_to : full_to;
                $('.box-inner .box.'+c).each(function(idx, el){
                    var $el = $(el);
                    if($el.attr('date_from') == date_from){
                            check++;
                            $el.addClass('selected');
                            $el.closest('.box-outer').addClass('selected');
                    }
                    if($el.attr('date_to') == date_to_use) {
                        check++;
                        $el.addClass('selected');
                        $el.closest('.box-outer').addClass('selected');
                    }
                    if(check == 1){
                        $el.addClass('selected');
                    }
                    if(check == 2){//check if need to scroll
                        $el.closest('.box-outer').addClass('candidate');
                    }
                });
                if(check < 2) $('.box-inner .box.'+c).removeClass('selected');//because we didn't find the date_to

                    //scroll the calendar, if needed, to make the selection visible
                $('.box-outer.candidate:first').removeClass('candidate');
                var box = c;
                var w1 = $('.calendar-body').width();
                var w2 = $('.'+c+'-box-outer:first').width();
                var box_involved = $('.'+box+'-box-outer.selected').length;
                var viewport = (w1 < 1.5*w2) ? 0 : 1;
                if(!!viewport && (box_involved < 2)){
                    $('.'+box+'-box-outer.candidate:first').removeClass('candidate');
                }
                var candidates = $('.'+box+'-box-outer.candidate').length;
                var wrapper = $('.'+box+'-box-wrapper');
                var hiddens = $('.'+box+'-box-outer.hidden').length;

                if(candidates != hiddens){
                    var m = wrapper.css('margin-right').split('px')[0];
                    var s = Math.abs(w2*(hiddens - candidates));
                    if(candidates < hiddens){
                            for(var i = 0; i < hiddens - candidates; i++) {
                                $('.' + box + '-box-outer.hidden').first().removeClass('hidden');
                            }
                            wrapper.css('marginRight', m-s).animate({'marginRight':m}, function(){
                                var last = $('.'+box+'-box-outer:last');
                                $('.calendar-scroll.'+c).removeClass('disabled');
                                if(!last.hasClass('hidden')) $('.calendar-scroll.right.'+c).addClass('disabled');
                            });
                    }
                    else{
                        wrapper.animate({'marginRight':m-s}, function(){
                            for(var i = 0; i < candidates - hiddens; i++) {
                                $('.'+box+'-box-outer').not('.hidden').last().addClass('hidden');
                            }
                            $(this).css('marginRight', m);
                            var position = $('.'+box+'-box-outer').position();
                            $('.calendar-scroll.'+c).removeClass('disabled');
                            if(Math.abs(position.left) < 100) $('.calendar-scroll.left.'+c).addClass('disabled');
                        });
                    }
                }
                $('.candidate').removeClass('candidate');
                $('.outer-box.selected').removeClass('selected');
            },
            selectPreviousPeriods(first, last){
                const vueInstance = this;
                var range = first.attr('range');
                var box_num1 = first.attr('box_num');
                var box_num2 = last.attr('box_num');
                var interval = box_num2 - box_num1 + 1;
                var from1 = first.attr('date_from');
                var from2 = last.attr('date_from');
                var to1 = first.attr('date_to');
                var to2 = last.attr('date_to');
                axios.get(`/api/reporting/calendar/select?range=${range}&from1=${from1}&from2=${from2}&to1=${to1}&to2=${to2}`).then((result) => {
                    _.each(vueInstance.calendarInfos.calendar_compares, (item) => {
                        if(item.comp_method == 'samePeriodMonth'){
                            item.date_from = result.data.m_date_from;
                            item.date_to = result.data.m_date_to;
                            item.full_to = item.date_to;
                            if(vueInstance.currentCompMethod == 'samePeriodMonth'){
                                vueInstance.date_compare_from = item.date_from;
                                vueInstance.date_compare_to = item.date_to;
                                vueInstance.date_full_to = item.date_to;
                            }
                        }
                        if(item.comp_method == 'samePeriodYear'){
                            item.date_from = result.data.y_date_from;
                            item.date_to = result.data.y_date_to;
                            item.full_to = item.date_to;
                            if(vueInstance.currentCompMethod == 'samePeriodYear'){
                                vueInstance.date_compare_from = item.date_from;
                                vueInstance.date_compare_to = item.date_to;
                                vueInstance.date_full_to = item.date_to;
                            }
                        }
                        if(item.comp_method == 'customCustom'){
                            item.date_from = from1;
                            item.date_to = to2;
                            item.full_to = item.date_to;
                            if(vueInstance.currentCompMethod == 'customCustom'){
                                vueInstance.date_compare_from = item.date_from;
                                vueInstance.date_compare_to = item.date_to;
                                vueInstance.date_full_to = item.date_to;
                            }
                        }
                    });
                });
            },
            init(select_status, first, last, box, period){
                const vueInstance = this;
                $('.box-inner .box').click(function(){
                    var $this = $(this);
                    if($this.hasClass('disabled')) return;
                    var activePeriod = vueInstance.getActivePeriod();
                    var check_selected = $this.hasClass('selected') ? 1 : 0;
                    if(activePeriod == 'quick'){
                        //$('ul.navbar.calendar.quick').find('li.selected').not('.custom').removeClass('selected');
                        vueInstance.currentMainMethod = 'custom';
                        vueInstance.currentCompMethod = vueInstance.currentCompSel[vueInstance.currentMainMethod];
                    }
                    else{
                        //$('ul.navbar.calendar.compare').find('li').not('.title').not('.custom').removeClass('selected');
                        vueInstance.currentCompMethod = vueInstance.currentMainMethod+'Custom';
                        vueInstance.currentCompSel[vueInstance.currentMainMethod] = vueInstance.currentCompMethod;
                    }
                    var cls = $this.attr('range');
                    //$('ul.navbar.calendar.'+activePeriod).find('.custom').removeClass('hidden').addClass('selected');
                    var custom = (activePeriod == 'quick') ? $('ul.navbar.calendar.quick.'+cls).find('li.custom') : $('ul.navbar.calendar.compare').find('li.custom');
                    if(select_status == 0){
                        select_status = 1;
                        box = cls;
                        period = $('.footer.period.active').attr('section');
                        if(activePeriod == 'quick'){
                            vueInstance.resetCalendarBoxes();
                        }
                        $('.box-inner .box').removeClass('selected');
                        first = $this.addClass('selected');
                        custom.attr('date_from', $this.attr('date_from'));
                        custom.attr('date_to', $this.attr('date_to'));
                        var date_from = $this.attr('date_from');
                        var date_to = $this.attr('date_to');
                        if(activePeriod == 'quick'){
                            vueInstance.selectPreviousPeriods(first, first);
                            _.each(vueInstance.calendarInfos.calendar_ranges[vueInstance.range], (item) => {
                                if(item.name == 'Custom'){
                                    item.date_from = date_from;
                                    item.date_to = date_to;
                                    item.range = vueInstance.range;
                                }
                            });
                            _.each(vueInstance.calendarInfos.calendar_compares, (item) => {
                                if(item.name == 'Custom'){
                                    item.date_from = date_from;
                                    item.date_to = date_to;
                                    item.full_to = item.date_to;
                                    item.range = vueInstance.range;
                                }
                            });
                            vueInstance.calendarInfos.calendar_mains[vueInstance.currentMainMethod]['date_from'] = date_from;
                            vueInstance.calendarInfos.calendar_mains[vueInstance.currentMainMethod]['date_to'] = date_to;
                            vueInstance.date_from = date_from;
                            vueInstance.date_to = date_to;
                        }
                        else{
                            _.each(vueInstance.calendarInfos.calendar_compares, (item) => {
                                if(item.name == 'Custom'){
                                    item.date_from = date_from;
                                    item.date_to = date_to;
                                    item.full_to = item.date_to;
                                    item.range = vueInstance.range;
                                }
                            });
                            vueInstance.date_compare_from = date_from;
                            vueInstance.date_compare_to = date_to;
                            vueInstance.date_full_to = date_to;
                        }
                    }
                    else{
                        select_status = 0;
                        last = $this.addClass('selected');
                        custom.attr('date_to', $this.attr('date_to'));
                        var check_box = $this.attr('range');
                        var check_period = $('.footer.period.active').attr('section');
                        if((check_box != box) || (check_period != period)){//we check that we are on the same calendar type: day, month, quarter or week
                            if(activePeriod == 'quick'){
                                vueInstance.resetCalendarBoxes();
                            }
                            $('.box-inner .box').removeClass('selected');
                            first = $this.addClass('selected');
                            custom.attr('date_from', $this.attr('date_from'));
                            custom.attr('date_to', $this.attr('date_to'));
                            var date_from = $this.attr('date_from');
                            var date_to = $this.attr('date_to');
                            if(activePeriod == 'quick'){
                                vueInstance.selectPreviousPeriods(first, first);
                                _.each(vueInstance.calendarInfos.calendar_ranges[vueInstance.range], (item) => {
                                    if(item.name == 'Custom'){
                                        item.date_from = date_from;
                                        item.date_to = date_to;
                                        item.range = vueInstance.range;
                                    }
                                });
                                _.each(vueInstance.calendarInfos.calendar_compares, (item) => {
                                    if(item.name == 'Custom'){
                                        item.date_from = date_from;
                                        item.date_to = date_to;
                                        item.full_to = item.date_to;
                                        item.range = vueInstance.range;
                                    }
                                });
                                vueInstance.calendarInfos.calendar_mains[vueInstance.currentMainMethod]['date_from'] = date_from;
                                vueInstance.calendarInfos.calendar_mains[vueInstance.currentMainMethod]['date_to'] = date_to;
                                vueInstance.date_from = date_from;
                                vueInstance.date_to = date_to;
                            }
                            else{
                                _.each(vueInstance.calendarInfos.calendar_compares, (item) => {
                                    if(item.name == 'Custom'){
                                        item.date_from = date_from;
                                        item.date_to = date_to;
                                        item.full_to = item.date_to;
                                        item.range = vueInstance.range;
                                    }
                                });
                                vueInstance.date_compare_from = date_from;
                                vueInstance.date_compare_to = date_to;
                                vueInstance.date_full_to = date_to;
                            }
                            last = null;
                            select_status = 1;
                            box = check_box;
                            period = check_period;
                            vueInstance.setSubmitButton();
                            return;
                        }
                        if(!!check_selected) return;

                        var check = 0;
                        $('.box-inner .box.'+cls).each(function(idx, el){
                            var $el = $(el);
                            if($el.hasClass('selected')){
                                check++;
                            }
                            if(check == 1){
                                $el.addClass('selected');
                            }
                        });

                        var first_from = first.attr('date_from');
                        var first_to = first.attr('date_to');
                        var last_from = last.attr('date_from');
                        var last_to = last.attr('date_to');

                        var date_from = (vueInstance.$dayjs(first_from) < vueInstance.$dayjs(last_from)) ? first_from : last_from;
                        var date_to   = (vueInstance.$dayjs(first_to) < vueInstance.$dayjs(last_to)) ? last_to : first_to;

                        custom.attr('date_from', date_from);
                        custom.attr('date_to', date_to);

                        if(activePeriod == 'quick'){
                            vueInstance.selectPreviousPeriods(first, last);
                            _.each(vueInstance.calendarInfos.calendar_ranges[vueInstance.range], (item) => {
                                if(item.name == 'Custom'){
                                    item.date_from = date_from;
                                    item.date_to = date_to;
                                    item.range = vueInstance.range;
                                }
                            });
                            _.each(vueInstance.calendarInfos.calendar_compares, (item) => {
                                if(item.name == 'Custom'){
                                    item.date_from = date_from;
                                    item.date_to = date_to;
                                    item.full_to = item.date_to;
                                    item.range = vueInstance.range;
                                }
                            });
                            vueInstance.calendarInfos.calendar_mains[vueInstance.currentMainMethod]['date_from'] = date_from;
                            vueInstance.calendarInfos.calendar_mains[vueInstance.currentMainMethod]['date_to'] = date_to;
                            vueInstance.date_from = date_from;
                            vueInstance.date_to = date_to;
                        }
                        else{
                            _.each(vueInstance.calendarInfos.calendar_compares, (item) => {
                                if(item.name == 'Custom'){
                                    item.date_from = date_from;
                                    item.date_to = date_to;
                                    item.full_to = item.date_to;
                                    item.range = vueInstance.range;
                                }
                            });
                            vueInstance.date_compare_from = date_from;
                            vueInstance.date_compare_to = date_to;
                            vueInstance.date_full_to = date_to;
                        }
                    }
                    vueInstance.setSubmitButton();
                });
                $(document).on("calendar-close", function(){
                    select_status = 0;
                    first = last = null;
                    box = null;

                    vueInstance.save_disabled = true;

                    vueInstance.state = 'closed';
                });
                $('.calendar-scroll').each(function(i, el){
                    var $el = $(el);
                    if($el.hasClass('disabled')) return;

                    var direction = ($el.hasClass('left')) ? 'left' : 'right';
                    if(direction == 'left'){
                        var box = $el.attr('range');
                        var hide = ($('.'+box+'-box-wrapper').hasClass('hidden')) ? true : false;
                        $('.'+box+'-box-wrapper').removeClass('hidden');//we remove the hidden class to calculate the width
                        var w1 = $('.calendar-body').width();
                        var w2 = $('.'+box+'-box-wrapper').width();

                        if(w2 < (w1+w2/4)){
                            $('.calendar-scroll.left.'+box).addClass('disabled');
                        }
                        if(hide) $('.'+box+'-box-wrapper').addClass('hidden');
                    }
                });
            }
        }
    }
</script>
